export function waitForOnline(): Promise<void> {
    if (navigator.onLine) return Promise.resolve();
    return new Promise((resolve) => {
        globalThis.addEventListener('online', () => resolve(), { once: true });
    });
}
